import React from 'react';
import reactModal from '@prezly/react-promise-modal';
import {ModalContainer} from '@components/modal/modal';
import {ModalContent, ModalFooter, ModalStyle, ModalTitle} from '@components/modal/styles';
import {Modal} from '@material-ui/core';
import {PrimaryButton} from '@screens/review-section3/pincode-authorisation/pin-code-form-styles';

interface AsyncModalParams {
  title: string;
  message: string | React.ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
}

interface AsyncRetryableModalParams extends AsyncModalParams {
  onConfirm: () => Promise<boolean>;
}

/**
 * Displays a confirmation prompt to the user which allows multiple submits and
 * only dismisses when an async callback result is successful
 * @param params
 */
export const AsyncRetryableModal = (params: AsyncRetryableModalParams) => {
  const {title, message, confirmLabel, cancelLabel, onConfirm} = params;

  return reactModal(({show, onSubmit, onDismiss}) => {
    const confirmHandler = async () => {
      if (!onConfirm) {
        onSubmit();
        return;
      }

      const canSubmit = await onConfirm();
      if (!canSubmit) {
        return;
      }

      onSubmit();
    };

    return (
      <ModalContainer title={title}
                      isOpen={show}
                      onCancelClickHandler={onDismiss}
                      onConfirmClickHandler={confirmHandler}
                      cancelLabel={cancelLabel}
                      confirmLabel={confirmLabel}>
        {message}
      </ModalContainer>
    );
  });
};
export const AsyncOkModal = (params: AsyncModalParams) => {
  const {title, message, confirmLabel} = params;

  return reactModal(({show, onSubmit, onDismiss}) => {
    return (
      <Modal open={show}
             disableEnforceFocus={true}
             disableEscapeKeyDown={true}
             onClose={onDismiss}>
        <ModalStyle
          top='50%'
          left='50%'>
          <ModalTitle>{title}</ModalTitle>
          <ModalContent>
            {message}
          </ModalContent>
          <ModalFooter>
            <PrimaryButton onClick={onSubmit}>
              {confirmLabel}
            </PrimaryButton>
          </ModalFooter>
        </ModalStyle>
      </Modal>
    );
  });
};
export const AsyncModal = (params: AsyncModalParams) => {
  const {title, message, confirmLabel, cancelLabel} = params;

  return reactModal(({show, onSubmit, onDismiss}) => {
    return (
      <ModalContainer title={title}
                      isOpen={show}
                      onCancelClickHandler={onDismiss}
                      onConfirmClickHandler={onSubmit}
                      cancelLabel={cancelLabel}
                      confirmLabel={confirmLabel}>
        {message}
      </ModalContainer>
    );
  });
};



// WEBPACK FOOTER //
// ./src/services/AsyncModals.tsx